import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-incentive-setup-grid',
  templateUrl: './incentive-setup-grid.component.html',
  styleUrls: ['./incentive-setup-grid.component.css']
})
export class IncentiveSetupGridComponent implements OnInit {
  currentUser: any;
  model: any;
  dataSource: any = [];
  showLoader: boolean = false;
  p: number = 1;
  columnNames = [{
    id: 'sno',
    value: 'No.',

  },
  {
    id: 'service_desc',
    value: 'Incentive Amount',
  }, {
    id: 'price_s',
    value: 'Times',
  }, {
    id: 'price_m',
    value: 'Type',
  }, {
    id: 'price_l',
    value: 'Incentive',
  }
  ];

  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService,
    private _arout: ActivatedRoute

  ) {
  }


  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.loginservice.getCollectiveIncentiveSetup(this.currentUser)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this.dataSource = data['data'];
          } else {
            this.dataSource = [];
          }
        }, error => { alert('Network Error getCollectiveIncentiveSetup API'); });
  }

  addvendor(id) {
    this.router.navigate(['incentive-setup']);
  }

}



// WEBPACK FOOTER //
// ./src/app/incentive-setup-grid/incentive-setup-grid.component.ts